<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M6 15C6 14.4477 6.44772 14 7 14H8C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16H7C6.44772 16 6 15.5523 6 15Z"
      :class="colorClass"
    />
    <path
      d="M12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H12Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6ZM20 8V6H4V8H20ZM4 10.0187V18H20V10.0187H4Z"
      :class="colorClass"
    />
    <path
      d="M6 15C6 14.4477 6.44772 14 7 14H8C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16H7C6.44772 16 6 15.5523 6 15Z"
      stroke="white"
      stroke-width="0.5"
    />
    <path
      d="M12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16H13C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14H12Z"
      stroke="white"
      stroke-width="0.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 6C22 4.89543 21.1046 4 20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6ZM20 8V6H4V8H20ZM4 10.0187V18H20V10.0187H4Z"
      stroke="white"
      stroke-width="0.5"
    />
    <g clip-path="url(#clip0_7066_3498)">
      <circle cx="18" cy="6" r="6" :class="colorClass" />
      <path
        d="M18.1953 3.17573C18.4556 2.94142 18.8777 2.94142 19.1381 3.17573L21.8047 5.57575C22.0651 5.81005 22.0651 6.18997 21.8047 6.42427L19.1381 8.82427C18.8777 9.05858 18.4556 9.05858 18.1953 8.82427C17.9349 8.58997 17.9349 8.21005 18.1953 7.97575L19.7239 6.60001H14.6667C14.2985 6.60001 14 6.33139 14 6.00001C14 5.66863 14.2985 5.40001 14.6667 5.40001H19.7239L18.1953 4.02427C17.9349 3.78995 17.9349 3.41005 18.1953 3.17573Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7066_3498">
        <rect width="12" height="12" fill="white" transform="translate(12)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
